import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles, allowPasswordChange }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F6F5F2]">
        <div className="text-[#4E544B] text-sm tracking-wide">Carregando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  // Force password change on first access. Only /trocar-senha is reachable in that state.
  if (user.must_change_password && !allowPasswordChange) {
    return <Navigate to="/trocar-senha" replace />;
  }

  if (roles && !roles.includes(user.role))
    return <Navigate to="/dashboard" replace />;

  return children;
}
